module.exports = __webpack_public_path__ + "fonts/iconfont.01e58d54.woff2";